// extracted by mini-css-extract-plugin
export default {"billTable":"vyapari-bill_billTable__xUjoU","heading":"vyapari-bill_heading__K+Bqw"};